import {cloneDeep, find, get} from 'lodash';
import {getBoolean, getString, getStringForDisplay} from 'Core/helpers/data';
import {LanguageDataObject} from "../dataObjects";
import Country from 'Core/country';
import {getCountryCodeByLanguageCode} from 'Language/const';

/**
 * Get input data from raw data
 * @param {?Object} [rawData] - Raw data received from IO.
 * @return {?LanguageDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	
	if (!getString(result, 'id')) return null;
	
	/** @type {LocaleObj} */
	const locale = find(Country.getAppLocaleList(), {locale: get(rawData, 'localeCode')});
	
	result = new LanguageDataObject(
		getString(result, 'id'),
		(!!locale ? locale.name : getStringForDisplay(get(result, 'displayName'))),
		getString(result, 'localeCode'),
		(!!locale ? locale.countryCode : getCountryCodeByLanguageCode(get(result, 'localeCode'))), 
		!getBoolean(result, 'active')
	);

	return result;
}

/**
 * Get output data from input data
 * @param {?LanguageDataObject} [inputData] - Input data.
 * @return {?string}
 */
export const output = inputData => getString(inputData, 'id', null, true);